var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('r-simple-card',{attrs:{"title":_vm.title}},[_c('r-color-picker',{attrs:{"color":_vm.config[_vm.colorField],"color-opacity":_vm.config[_vm.opacityField]},on:{"change":_vm.changeProperty}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }